import styled from 'styled-components';

export const ReportButtonContainer = styled.div`
  display: flex;
  align-items: center;
  font-size: 14px;

  @media (max-width: 512px) {
    flex-direction: column;
    text-align: center;
  }

  .btn-description {
    margin-left: 16px;
    line-height: 16px;

    @media (max-width: 512px) {
      margin-left: 0;
    }

    .first-line {
      @media (max-width: 512px) {
        margin-top: 12px;
      }
    }

    .second-line {
      margin-top: 2px;
    }

    .red {
      color: ${({ theme }) => theme.colors.color_red};
    }

    .gray {
      color: ${({ theme }) => theme.colors.color_darkgray};
    }

    .small {
      font-size: ${({ theme }) => theme.fontSize.sm};
    }
  }
`;
